import { Paper, PaperProps } from '@material-ui/core';
import React from 'react';

export type HeavyPaperProps = Omit<PaperProps, "elevation"> & {

}

export function HeavyPaper (props: HeavyPaperProps) {
    return (
        <Paper elevation={10} {...props} />
    )
}